module.exports = __webpack_public_path__ + "media/images/report_problem-24px-red-3f12562b0cd5a2c270579492e901e69e.svg";